/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AdminTagDto, AdminTagRequestDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AdminTagService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AdminTagService
   * @name GetTag1
   * @summary Get Tag by ID
   * @request GET:/v1/admin/tags/{tagId}
   * @secure
   */
  getTag1 = (tagId: number, params: RequestParams = {}) =>
    this.http.request<AdminTagDto, any>({
      path: `/v1/admin/tags/${tagId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminTagService
   * @name UpdateTag
   * @summary Update Tag
   * @request PUT:/v1/admin/tags/{tagId}
   * @secure
   */
  updateTag = (tagId: number, data: AdminTagRequestDto, params: RequestParams = {}) =>
    this.http.request<AdminTagDto, any>({
      path: `/v1/admin/tags/${tagId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminTagService
   * @name DeleteTag
   * @summary Delete Tag
   * @request DELETE:/v1/admin/tags/{tagId}
   * @secure
   */
  deleteTag = (tagId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/tags/${tagId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminTagService
   * @name GetTags1
   * @summary Get Tags
   * @request GET:/v1/admin/tags
   * @secure
   */
  getTags1 = (
    query?: {
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminTagDto[], any>({
      path: `/v1/admin/tags`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminTagService
   * @name CreateTag
   * @summary Create Tag
   * @request POST:/v1/admin/tags
   * @secure
   */
  createTag = (data: AdminTagRequestDto, params: RequestParams = {}) =>
    this.http.request<AdminTagDto, any>({
      path: `/v1/admin/tags`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
